import CodeHighlight from './code-highlight';

export default {
  tag: 'code',
  format: `\`\`\`(language)\n(code)\n\`\`\``,
  sourcePipeline: (source: string) => source,
  componentFn: (node: any) => {
    return (
      <CodeHighlight className={node.className} {...node}>
        {node.children}
      </CodeHighlight>
    );
  }
};
